export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "accept": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ok"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
        "srDismissModal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dismiss modal"])}
      },
      "fr": {
        "accept": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valider"])},
        "cancel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
        "srDismissModal": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer la fenêtre"])}
      }
    }
  })
}
